import React, { useState } from 'react'
import NavBar from '../../common/NavBar/NavBar'
import clsx from 'clsx'
import useDocumentScrollThrottled from '../../common/hooks/useDocumentScrollThrottled'
import PropTypes from 'prop-types'

const headerClassNames = (hideHeader) =>
  clsx('fixed top-0 left-0 w-full h-20 z-10 transition duration-700', {
    '-translate-y-full': hideHeader
  })

const APPEAR_BEFORE = 800
const MINIMUM_SCROLL = 64
const TIMEOUT_DELAY = 200

const Header = ({ links }) => {
  const [hideNavBar, setHideNavBar] = useState(null)
  const [navActive, setNavActive] = useState(false)

  useDocumentScrollThrottled((callbackData) => {
    const { previousScrollTop, currentScrollTop } = callbackData
    const isScrolledDown = previousScrollTop < currentScrollTop
    const isMinimumScrolled = currentScrollTop > MINIMUM_SCROLL

    setTimeout(() => {
      if (currentScrollTop < APPEAR_BEFORE) {
        setHideNavBar(null)
      } else {
        setHideNavBar(isScrolledDown && isMinimumScrolled)
      }
    }, TIMEOUT_DELAY)
  })

  return (
    <header className={headerClassNames(!navActive && hideNavBar)}>
      <NavBar
        links={links}
        navActive={navActive}
        setNavActive={setNavActive}
      />
    </header>
  )
}

export default Header

Header.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired
    })
  )
}
